import {Component, HostListener, input, OnInit, output} from "@angular/core";
import {AppNavigationController, MK_APP_NAVIGATION} from "../_controllers/app-navigation.controller";
import {AppNavigationService} from "../_services/app-navigation.service";
import {AppNavigationFlags} from "../_interfaces/AppNavigationFlags";
import {AppNavigationModel} from "../_models/AppNavigationModel";
import {AppMenuItem} from "../_models/AppMenuItem";
import {GlobalConfig} from "../../../common/configs/GlobalConfig";

@Component({
  selector: "link-app-navigation-view",
  templateUrl: "./app-navigation.view.html",
  styleUrls: ["./app-navigation.view.scss"],
  providers: [
    AppNavigationController,
    AppNavigationService,
  ],
})
export class AppNavigationView implements OnInit {

  appNavigationFlags = input.required<AppNavigationFlags>();
  onPinToggle = output<any>();
  onDeactivation = output<any>();

  protected readonly model: AppNavigationModel;
  protected showAppInfo = false;
  protected appInfo: string = '';

  constructor(private controller: AppNavigationController) {
    this.model = this.controller.getModel(MK_APP_NAVIGATION);
    this.appInfo = `${GlobalConfig.version} / ${GlobalConfig.buildNumber} / ${GlobalConfig.buildTimestamp}`;
  }

  ngOnInit() {
    this.controller.handle('Init', {});
  }

  protected togglePin(): void {
    this.onPinToggle.emit({});
  }

  protected menuItemClicked(menuItem: AppMenuItem, event: any): void {
    this.controller.handle('MenuItemClicked', {
      menuItem: menuItem,
      event: event,
    });

    if(this.appNavigationFlags().mobileNavigation$() && menuItem.type !== 'parent-item') {
      this.deactivateMenu();
    }
  }

  protected deactivateMenu(): void {
    this.onDeactivation.emit({});
  }

  @HostListener('document:keydown', ['$event'])
  protected keyDownEvent(event: KeyboardEvent) {
    if(event.ctrlKey || event.metaKey) {
      if(event.key === '/') {
        this.showAppInfo = !this.showAppInfo;
      }
    }
  }
}
